import { services } from '@/shared/plugins/services';

const Priority = {
  STOP_RECALCULATION: 0,
  PLAYBACK_ENABLED: 1,
  DEFAULT: 2,
};

const getProgramPriority = (program = {}) => {
  if (program.stopRecalculation) {
    return Priority.STOP_RECALCULATION;
  }

  if (!program.isPlaybackDisabled) {
    return Priority.PLAYBACK_ENABLED;
  }

  return Priority.DEFAULT;
};

export const sortProgramsByPriority = (programs = []) => {
  return programs.toSorted((a, b) => {
    const priority = getProgramPriority(a) - getProgramPriority(b);

    return priority || (b.since - a.since);
  });
};

export default ({ product, currentTime }) => {
  const liveManager = services.resolve('liveManager');
  const time = services.resolve('time');

  const programs = liveManager.getSince(time, {
    since: currentTime,
    till: currentTime.add(1, 's'),
  }, product);

  if (programs.length) {
    const sortedPrograms = sortProgramsByPriority(programs);

    return sortedPrograms[0];
  }
};
